import styled from 'styled-components/macro';
import { ContextType } from 'type';
type HeaderWrapperProps = {
  backgroundColor: string;
  color: string;
  width?: string;
};
export const HeaderWrapper = styled.div<HeaderWrapperProps>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color};
  width: ${({ width }) => width};
  padding: 0em 1em;
  border-radius: 10em;
  display: block;
  text-align: center;
`;

type PictureWrapperProps = {
  gender: ContextType['gender'];
  borderColor: string;
  url?: any;
};

function getProfileImage(gender: any, url: any) {
  if (gender === 'url') return url;
  return `/assets/${gender}.jpg`;
}

export const PictureWrapper = styled.div<PictureWrapperProps>`
  width: 120px;
  height: 120px;
  border-radius: 60px;
  background-color: white;
  background-image: url(${({ gender, url }) => getProfileImage(gender, url)});
  background-size: cover;
  border: 5px solid ${({ borderColor }) => borderColor};
  background-position: center;
  background-repeat: no-repeat;
`;
